/**
 * Section établissements du profil
 */
import { Tag } from '@carbon/react'
import { Building, CheckmarkFilled, Time } from '@carbon/icons-react'
import type { EstablishmentMembershipDetail } from '@sphere/user/domain'
import { formatDateFrMonthYear } from '@sphere/shared/util'
import styles from './profile-establishments.module.scss'

interface ProfileEstablishmentsProps {
  establishments: EstablishmentMembershipDetail[]
}

export function ProfileEstablishments({
  establishments,
}: ProfileEstablishmentsProps) {
  if (establishments.length === 0) {
    return (
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionTitle}>
            <Building size={20} />
            Établissements
          </h3>
        </div>
        <p className={styles.empty}>Aucun établissement</p>
      </div>
    )
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>
          <Building size={20} />
          Établissements
          <Tag type="gray" className={styles.badge}>
            {establishments.length}
          </Tag>
        </h3>
      </div>
      <div className={styles.items}>
        {establishments.map(establishment => (
          <div
            key={establishment.membershipId}
            className={`${styles.item} ${!establishment.isActive ? styles.itemInactive : ''}`}
          >
            <div className={styles.itemHeader}>
              <div className={styles.itemContent}>
                <div className={styles.itemTitleRow}>
                  <h4 className={styles.itemTitle}>
                    {establishment.establishmentName}
                  </h4>
                  {establishment.isActive ? (
                    <CheckmarkFilled
                      size={16}
                      style={{ color: 'var(--cds-support-success)' }}
                    />
                  ) : (
                    <Time size={16} className={styles.itemMeta} />
                  )}
                </div>
                {establishment.establishmentUai && (
                  <p className={styles.itemMeta}>
                    UAI: {establishment.establishmentUai}
                  </p>
                )}
              </div>
              <Tag type="outline">{establishment.role.name}</Tag>
            </div>
            <div className={styles.itemMeta}>
              Depuis {formatDateFrMonthYear(establishment.joinedAt)}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
